import React from 'react';
import ReactDOM from 'react-dom/client';
import RouteUrls from './RouteUrls';
import './root.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouteUrls />
  </React.StrictMode>
);
;
